import { useCallback, useEffect, useState } from 'react';

import Axios from '../../../Assets/Axios/Axios';

import { toCurrencyString } from '../../../Helpers';

import { FindProfessionalOrdersByOrderStatus } from '../../../Server/Query';



/**
 *
 * @param {string} status
 * @param {string} professionalId
 * @returns {{
    orders: {
      id:string,
      referenceId:string,
      date:string,
      note:string,
      phoneNumber:string,
      name:string
      place:string
      package:{
        name:string,
        price:number
      }}[];
    hasErrored: boolean;
    updateOrders: () => void;
  }}
 */

function useProfessionalOrders(status, professionalId) {
  const [orders, setOrders] = useState([]);
  const [hasErrored, setHasErrored] = useState(false);

  const fetchOrders = useCallback(() => {
    const query = FindProfessionalOrdersByOrderStatus({ orderStatus: status });

    Axios(query).then(({ data, errors }) => {
      if (errors) {
        setHasErrored(true);
        return undefined;
      }

      setOrders((data.professionalOrders ?? []).map(order => parseOrder(order)));
    });
  }, [status]);

  useEffect(fetchOrders, [fetchOrders]);

  return { orders, hasErrored, updateOrders: fetchOrders };
}

function parseOrder(order) {
  const timeFormatter = new Intl.DateTimeFormat(undefined, {
    timeStyle: 'short',
  });

  const date = order.date ?? order.orderDate;
  const time = order.time ?? order.orderTime;

  return {
    id: order.id,
    referenceId: order.referenceId ?? order.reference_id,
    date: date ? `${date.split('T')[0]}${time ? ' ' + timeFormatter.format(new Date(time)) : ''}` : '',
    note: order.note ?? order.serviceNote,
    phoneNumber: order.eventBooker?.mobileNumber ?? null,
    name: [order.eventBooker?.firstName, order.eventBooker?.lastName].filter(Boolean).join(' '),
    place: order.place,
    package: {
      name: order.servicePackage?.name ?? null,
      price: order.servicePackage?.price != null ? toCurrencyString(order.servicePackage.price) : null,
    },
  };
}

export default useProfessionalOrders;
